import React from 'react';
import PropTypes from 'prop-types';

export function ProfilePanel({
  icon: Icon,
  title,
  headerExtra = null,
  children,
  bodyClassName = '',
  variant = 'default',
}) {
  const rootClass = [
    'y-profile-panel',
    variant === 'loden' ? 'y-profile-panel--loden' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={rootClass}>
      <div className={`y-profile-panel__header${headerExtra ? ' y-profile-panel__header--split' : ''}`}>
        <div className="y-profile-panel__heading">
          {Icon ? <Icon className="y-profile-panel__icon" aria-hidden="true" /> : null}
          <h3 className="y-profile-panel__title">{title}</h3>
        </div>
        {headerExtra}
      </div>
      <div className={`y-profile-panel__body ${bodyClassName}`.trim()}>{children}</div>
    </section>
  );
}

ProfilePanel.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  headerExtra: PropTypes.node,
  children: PropTypes.node,
  bodyClassName: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'loden']),
};

export function ProfileTip({ label, children }) {
  return (
    <section className="y-profile-tip" data-testid="profile-field-tip">
      <p className="y-profile-tip__label">{label}</p>
      <p className="y-profile-tip__text">{children}</p>
    </section>
  );
}

ProfileTip.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export function ProfileStatChip({ value, label }) {
  return (
    <div className="y-profile-stat-chip">
      <p className="y-profile-stat-chip__value">{value}</p>
      <p className="y-profile-stat-chip__label">{label}</p>
    </div>
  );
}

ProfileStatChip.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
};
